import React from 'react';
import { ProjectMeta } from '../types';
import { ProjectDomainSettings } from './ProjectDomainSettings';

interface ProjectSettingsModalProps {
    open: boolean;
    project: ProjectMeta;
    onClose: () => void;
    onUpdate: () => void;
}

export const ProjectSettingsModal: React.FC<ProjectSettingsModalProps> = ({ open, project, onClose, onUpdate }) => {
    if (!open) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
                <div className="flex justify-between items-center p-6 border-b border-slate-200">
                    <h2 className="text-xl font-bold text-slate-800">Configurações do Projeto: {project.name}</h2>
                    <button onClick={onClose} className="text-slate-400 hover:text-slate-600">
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>

                <div className="p-6">
                    <ProjectDomainSettings project={project} onUpdate={onUpdate} />

                    <div className="mt-8 pt-6 border-t border-slate-200 flex justify-end">
                        <button
                            onClick={onClose}
                            className="px-4 py-2 bg-slate-100 text-slate-700 rounded-md hover:bg-slate-200 font-medium"
                        >
                            Fechar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};
